import { gql } from "@apollo/client";

const GETUSERSALESCOUNT = gql`
  query getUserSalesDoneCount($agentId: [ID], $timeFrame: String) {
    getUserSalesDoneCount(agentId: $agentId, timeFrame: $timeFrame) {
      success
      error
      count
    }
  }
`;

export default GETUSERSALESCOUNT;
